module.exports = __webpack_public_path__ + "resources/ee0f44576fb1df659f72845b5086cd36.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/oversized-super-villain.png
// module id = 216
// module chunks = 0